import { Record } from 'immutable';

export interface DeviceCustomizationInterface {
  phoneHdSystem: string;
  language: string;
  url: string;
}

const phoneHdSystem = '';
const language = '';
const url = '';

export const initialState: DeviceCustomizationInterface = {
  phoneHdSystem: phoneHdSystem,
  language: language,
  url: url
};

export default class DeviceCustomizationState extends Record(initialState) { }
